module.exports = __webpack_public_path__ + "media/images/back_button-8c793923.png";